import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import HeaderForm from "layouts/landingpage/HeaderForm";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import styled from "styled-components";
import Avatar from "../../../assets/images/users/avatar-man.png";
import { OrderEventService, Certificate } from "services";
import { useParams } from "react-router-dom";
import logoLight from "../../../assets/images/myachery/logo_myarhery.svg";
import { useSelector } from "react-redux";
import { getAuthenticationStore } from "store/slice/authentication";
// import QRCode from "qrcode.react";
import { QRCode } from "react-qr-svg";
import fileSaver from "file-saver";
import { LoadingScreen } from "components";

import DownloadableCertificate from "./DownloadableSertificate";

const H5 = styled.h5`
  font-size: 13px;
  line-height: 19px;
  color: #74788d;
  font-weight: normal;
`;

const CheckoutEvent = () => {
  const [loading, setLoading] = useState(true);
  const [info, setInfo] = useState(null);
  const { id } = useParams();
  let { userProfile } = useSelector(getAuthenticationStore);
  const [loadingCertificate, setLoadingCertificate] = useState(false);
  const [certificates, setCertificates] = React.useState(null);

  const handleClickPayment = (snapToken = "") => {
    window.snap.pay(`${info != null && info.transactionInfo ? info.transactionInfo.snapToken : snapToken}`, {
      onSuccess: function () {
        console.log("success");
      },
      onPending: function () {
        console.log("pending");
      },
      onError: function () {
        console.log("error");
      },
      onClose: function () {
        console.log("customer closed the popup without finishing the payment");
      },
    });
  };

  useEffect(async () => {
    const { data, errors, message, success } = await OrderEventService.get({
      id,
    });
    setLoading(false);
    if (success) {
      if (data) {
        if (data.transactionInfo.statusId == 4) {
          handleClickPayment(data.transactionInfo.snapToken);
        }

        setInfo(data);
      }
    } else {
      console.error(message, errors);
    }
  }, []);

  let formatter = new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
  });

  React.useEffect(() => {
    if (!info) {
      return;
    }

    const getCertifList = async () => {
      setLoadingCertificate(true);
      const result = await Certificate.getByParticipantId({
        participant_id: info.participant.id,
      });
      if (result.data) {
        setCertificates(result.data);
      }
      setLoadingCertificate(false);
    };
    getCertifList();
  }, [info]);

  const handleCertificateDownload = async (typeCertificate) => {
    setLoading(true);
    const download = await Certificate.download({
      participant_id: info.participant.id,
      type_certificate: typeCertificate,
    });

    if (download.data) {
      const { fileName, fileBase64 } = download.data;
      fileSaver.saveAs(fileBase64, fileName || "certificate.pdf");
    }
    // TODO: handle error

    setLoading(false);
  };

  return (
    <React.Fragment>
      <MetaTags>
        <title>Checkout Events | MyAchery</title>
      </MetaTags>
      {/* import navbar */}
      <HeaderForm />

      <Container fluid className="px-5 p-2 mb-5">
        <LoadingScreen loading={loading} />
        <Card>
          <CardBody>
            <Row>
              <Col md={1}>
                <div>
                  <img
                    src={Avatar}
                    alt=""
                    className="avatar-md rounded-circle img-thumbnail"
                    style={{ height: "auto" }}
                  />
                </div>
              </Col>
              <Col md={4}>
                <H5>Welcome to MyArchery.id dashboard</H5>
                <div className="text-muted">
                  <h4>{userProfile?.name}</h4>
                  {/* <H5>Klub FAST</H5> */}
                </div>
              </Col>
              <Col md={4}>
                <div>
                  <div className="d-flex">
                    <div className="text-muted" style={{ marginRight: "1rem" }}>
                      <h4>No. Ponsel</h4>
                      <H5>{userProfile?.phoneNumber}</H5>
                    </div>
                    <div className="text-muted">
                      <h4>Email</h4>
                      <H5>{userProfile?.email}</H5>
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={3}>
                <div className="float-md-end">
                  <Button
                    disabled
                    href="/full-day"
                    type="button"
                    size="sm"
                    style={{ backgroundColor: "#0D47A1" }}
                  >
                    Setting
                  </Button>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {info && (
          <Card>
            <CardBody>
              <Row>
                <Col md={3} sm={12}>
                  <div style={{ textAlign: "center" }} className="mb-4">
                    <img
                      src={
                        info.archeryEvent != undefined &&
                        info.archeryEvent.poster != null &&
                        info.archeryEvent.poster
                          ? info.archeryEvent.poster
                          : logoLight
                      }
                      height="130"
                    />
                  </div>
                </Col>
                <Col md={9} sm={12}>
                  <Row>
                    <Col sm={12}>
                      <H5 className="mx-md-5">Detail Order</H5>
                      <div className="d-md-flex">
                        <div className="mx-md-5 text-muted">
                          <H5>ID ORDER</H5>
                          <h4>{info.transactionInfo?.orderId}</h4>
                        </div>
                        <div className="mx-md-5 text-muted">
                          <H5>Total</H5>
                          <h4>{formatter.format(info.transactionInfo?.total)}</h4>
                        </div>
                        <div className="mx-md-5 text-muted">
                          <H5>Status Pembayaran</H5>

                          {info.transactionInfo != undefined &&
                          info.transactionInfo.statusId == 1 ? (
                            <h4 style={{ color: "green" }} className="fw-medium">
                              <i>{info.transactionInfo.status}</i>
                            </h4>
                          ) : info.transactionInfo != undefined &&
                            info.transactionInfo.statusId == 4 ? (
                            <h4 style={{ color: "red" }} className="fw-medium">
                              <i className="me-sm-2">{info.transactionInfo.status}</i>
                              <span
                                className="btn btn-primary mt-2"
                                onClick={() => {
                                  window.location.reload();
                                }}
                              >
                                Check status
                              </span>
                            </h4>
                          ) : (
                            <h4 style={{ color: "gray" }} className="fw-medium">
                              <i>{info.transactionInfo ? info.transactionInfo.status : ""}</i>
                            </h4>
                          )}
                        </div>
                        <div>
                          {/* <QRCode value={info.transactionInfo?.orderId} /> */}
                          {info.transactionInfo != undefined &&
                          info.transactionInfo.statusId == 0 ? (
                            <QRCode
                              bgColor="#FFFFFF"
                              fgColor="#000000"
                              level="Q"
                              style={{ width: 100 }}
                              value={`${info.transactionInfo?.orderId}`}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <hr />
                    </Col>
                    <Col sm={12}>
                      <H5 className="mx-md-5">Event</H5>
                      <div className="d-md-flex">
                        <div className="mx-md-5 text-muted">
                          <h5>{info.archeryEvent?.eventName}</h5>
                        </div>
                        <div className="mx-md-5 text-muted">
                          <H5>Lokasi</H5>
                          <h5>{info.archeryEvent?.location}</h5>
                        </div>
                        <div className="mx-md-5 text-muted">
                          <H5>Peserta</H5>
                          {info.participant && info.participant.members ? (
                            info.participant.members.map((i) => <li key={i}>{i.name}</li>)
                          ) : (
                            <></>
                          )}
                        </div>
                        <div className="mx-md-5 text-muted">
                          <H5>Kategori</H5>
                          <h6>{info.participant?.categoryLabel}</h6>
                        </div>
                      </div>
                      <hr />
                    </Col>

                    <Col sm={12}>
                      <div className="d-flex justify-content-between">
                        <div className="mx-md-5 text-muted">
                          <H5>Tanggal Kualifikasi</H5>
                          <p>{info.archeryEvent?.eventStartDatetime}</p>
                        </div>
                        <div className="mx-md-5 text-muted">
                          {info.transactionInfo != undefined &&
                          info.transactionInfo.statusId == 1 ? (
                            <div>
                              <Button
                                href={
                                  info.participant
                                    ? "/archer/event/marathon/qualification/schedule/" + info.participant.members[0].id
                                    : ""
                                }
                                type="button"
                                size="sm"
                                style={{ backgroundColor: "#0D47A1" }}
                              >
                                Pilih Jadwal Kualifikasi
                              </Button>
                            </div>
                          ) : null}
                          <Button
                            href={
                              info.participant
                                ? "/display/stages/" + info.archeryEvent.eventSlug
                                : ""
                            }
                            type="button"
                            size="sm"
                            style={{ backgroundColor: "#0D47A1" }}
                          >
                            Jadwal Eliminasi
                          </Button>
                        </div>
                      </div>
                      <hr />
                    </Col>

                    {info?.transactionInfo?.statusId === 1 &&
                      info?.archeryEvent?.id &&
                      (loadingCertificate ? (
                        <Col sm={12}>
                          <div className="d-md-flex mx-md-5 text-muted">Memuat sertifikat...</div>
                        </Col>
                      ) : (
                        certificates?.length && (
                          <Col sm={12}>
                            <H5 className="mx-md-5 mb-3">Sertifikat yang Diperoleh</H5>

                            <div className="d-md-flex mx-md-5">
                              <Row className="mb-5">
                                {certificates.map((certificate) => (
                                  <Col md="6" lg="4" key={certificate.data.id}>
                                    <DownloadableCertificate
                                      certificate={certificate}
                                      onDownload={() =>
                                        handleCertificateDownload(certificate.data.typeCertificate)
                                      }
                                    />
                                  </Col>
                                ))}
                              </Row>
                            </div>
                          </Col>
                        )
                      ))}

                    {info.transactionInfo != undefined && info.transactionInfo.statusId == 4 ? (
                      <Button
                        type="button"
                        size="md"
                        onClick={handleClickPayment}
                        style={{ backgroundColor: "#0D47A1" }}
                      >
                        LAKUKAN PEMBAYARAN
                      </Button>
                    ) : null}
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
        )}
      </Container>
    </React.Fragment>
  );
};

export default CheckoutEvent;
